var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"goodlist"},_vm._l((_vm.list),function(good,index){return _c('li',{key:index},[_c('img',{attrs:{"src":good.img,"alt":""}}),_c('p',[_vm._v(_vm._s(good.goodname))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }